module.exports = __webpack_public_path__ + "static/media/4.13c361d5.jpg";